// extracted by mini-css-extract-plugin
export default {"statusBadgeContainer":"StatusBadge_statusBadgeContainer__2n6LP"};